










import Vue from 'vue';
import WorkflowJob from './WorkflowJob.vue';

export default Vue.extend({
  name: 'WorkflowJobTab',
  data() {
    return {
      closeFailed: false
    };
  },
  components: {
    WorkflowJob
  },
  beforeRouteLeave(this: any) {
    if (window.opener) {
      window.close();
    } else {
      this.closeFailed = true;
    }
  }
});
